import { h, render } from 'preact'
import App from './app'

const rootNode = document.getElementById('app')

render(
  <App/>,
  rootNode!
)
